import { createAction, props } from '@ngrx/store';
import { ConfiguracionGeneral, ConfiguracionGeneralForm } from '@core/models'
import { ResponseBadRequest } from '@core/interfaces';

export const BUSINESS_SETTING_FIND = createAction('[Business Setting] Find', props<{ id: string }>());
export const BUSINESS_SETTING_FIND_ALL = createAction('[Business Setting] Find All');

export const BUSINESS_SETTING_FIND_SUCCESS = createAction('[Business Setting] Find Success', props<{ businessSetting: ConfiguracionGeneral }>());
export const BUSINESS_SETTING_FIND_ALL_SUCCESS = createAction('[Business Setting] Find All Success', props<{ businessSettingList: ConfiguracionGeneral[] }>());

export const BUSINESS_SETTING_FAILURE = createAction('[Business Setting] Failure', props<{ error: ResponseBadRequest }>());

export const BUSINESS_SETTING_UPDATE_LOADING = createAction('[Business Setting] Update Loading', props<{ loading: boolean }>());
export const BUSINESS_SETTING_UPDATE_FORM = createAction('[Business Setting] Update Form', props<{ businessSettingForm: ConfiguracionGeneralForm }>());
export const BUSINESS_SETTING_EDIT_MODE = createAction('[Business Setting] Edit Mode', props<{ editMode: boolean, isEditing: boolean }>());
export const BUSINESS_SETTING_UPDATE_ID = createAction('[Business Setting] Update Id', props<{ businessSettingId: string |null }>());

export const BUSINESS_SETTING_CREATE_VIEW = createAction('[Business Setting] Create View');
export const BUSINESS_SETTING_UPDATE_VIEW = createAction('[Business Setting] Update View', props<{ businessSettingId: string }>());

export const BUSINESS_SETTING_CREATE = createAction('[Business Setting] Create');
export const BUSINESS_SETTING_UPDATE = createAction('[Business Setting] Update');
export const BUSINESS_SETTING_REMOVE = createAction('[Business Setting] Remove', props<{ id: string }>());

export const BUSINESS_SETTING_CREATE_COMPLETED = createAction('[Business Setting] Create Completed');
export const BUSINESS_SETTING_UPDATE_COMPLETED = createAction('[Business Setting] Update Completed');
export const BUSINESS_SETTING_REMOVE_COMPLETED = createAction('[Business Setting] Remove Completed');

export const BUSINESS_SETTING_RESET = createAction('[Business Setting] Reset');
export const BUSINESS_SETTING_RESET_FORM = createAction('[Business Setting] Reset Form');
export const BUSINESS_SETTING_RESET_ERROR = createAction('[Business Setting] Reset Error');
export const BUSINESS_SETTING_CLEAR_STATE = createAction('[Business Setting] Clear State');

export const BUSINESS_SETTING_UPDATE_FORM_VALID = createAction('[Business Setting] Update Form Valid', props<{ validForm: boolean }>());
